/* eslint-disable react-hooks/exhaustive-deps */
import useDataTable from '../../../hooks/useDataTable';

export default function ShowTable({ data }) {
    const columns = [
        {
            name: 'Item Name',
            selector: (row) => row.drug_name,
            sortable: true,
            wrap: true,
        },
        {
            name: 'PO Number',
            selector: (row) => row.po_no,
            sortable: true,
        },
        {
            name: 'Available Quantity',
            selector: (row) => row.available_stock || 0,
            sortable: true,
        },
        {
            name: 'Distribution Quantity',
            selector: (row) => row.supplied_qty,
            sortable: true,
        },
    ];

    const search_column = {
        drug_name: 'Name',
    };
    return useDataTable({ columns, data, search_column, pagination: false });
}
